/*
 * Endereços que vêm de fora e viram link na tela.
 *
 * Site do parceiro, link de passo do tutorial e endereço de autorização chegam
 * do manifesto do conector ou da resposta do servidor. Num `href` ou num
 * `window.location`, um esquema como `javascript:` executa no painel, com a
 * sessão de quem clicou — por isso só http e https viram link.
 */
function urlSegura(endereco) {
  return /^https?:\/\//i.test(endereco || '') ? endereco : null;
}

export { urlSegura };
